module.exports = __webpack_public_path__ + "media/packs/src/assets/images/skill-tracking-50399c3bff4ad34103932200450faa9e.png";